import { get } from "lodash"
import { contentMapBody } from "@/utils/contentMapBody"
import type { ContentMapEntry } from "@/utils/contentMapTypes"
import {
  returnObjectWithPath,
  type UseContentProps,
} from "@/utils/useContentProps"

export function buildContentMapEntry(
  matrixContent: unknown,
  props: UseContentProps,
  overrides: Partial<Omit<ContentMapEntry, "refId" | "path">> = {}
): Omit<ContentMapEntry, "refId"> | null {
  const normalized = returnObjectWithPath(props)
  if (!normalized.path) return null

  const content = get(matrixContent, normalized.path) as
    | Record<string, unknown>
    | undefined

  return {
    path: normalized.path,
    assetId: (content?.assetId as string | undefined) ?? "",
    prodAssetId: (content?.prodAssetId as string | undefined) ?? "",
    contentLengthMatch: content?.contentLengthMatch as boolean | undefined,
    contentBody: content ? contentMapBody(content) : "",
    updated: (content?.updated as string | undefined) ?? "",
    failed: !content,
    sourceKind: overrides.sourceKind ?? "runtime",
    ...overrides,
  }
}
